document.addEventListener('DOMContentLoaded', function () {
    populateDeliveryGroups();
    //carousell
    var splide = new Splide('.splide', {
        type: 'loop',
        perPage: 3,
        speed: 300,
        pauseOnHover: false,
        pauseOnFocus: false,
        breakpoints: {
            769: {
                perPage: 2,
            }
        },
        focus: 'center',
        autoplay: true,
        interval: 2000,
        pagination: false,
    });
    splide.mount();

    const buttons = document.querySelectorAll('[data-open-modal]')
    const modal = document.querySelector('.x-mas-modal--container')
    const modalAllSteps = modal.querySelectorAll('[data-step]')
    const proteinStep = modal.querySelector('[data-step="protein"]')
    const datesStep = modal.querySelector('[data-step="dates"]')
    const dateStepContinue = modal.querySelector('.dates.continue')
    const breafastStep = modal.querySelector('[data-step="addons"]')
    const confirmationStep = modal.querySelector('[data-step="confirmation"]')
    const proteinButtons = document.querySelectorAll('.protein-group button')
    const proteinContinueButton = document.querySelector('.protein.continue')
    const modalClose = modal.querySelector('.modal-close')

    modalClose.addEventListener('click', function () {
        modal.classList.remove('is-active')
        document.body.classList.remove('modal-open')
        modalAllSteps.forEach(step => {
            step.classList.remove('active')
        })
        clearAllProteinSelection()
        proteinContinueButton.disabled = true
        proteinStep.classList.add('active')
    })

    const qtySelectors = document.querySelectorAll('.bundle_size__wrapper select');
    qtySelectors.forEach((selector) => {
        selector.addEventListener('change', function (e) {
            const card = e.target.closest('.product_card-one-month');
            const stream = card.dataset.stream;
            const quantity = e.target.value || card.dataSet.quantity;
            const handlePrepaid = `bft-${stream}-${quantity}-meals-week-prepaid`;
            const handleWeekly = `bft-${stream}-${quantity}-meals-week-weekly`;
            card.dataset.quantity = quantity;
            if (quantity == "10") {
                defaultCollection = campaign__10;
            } else if (quantity == "8") {
                defaultCollection = campaign__8;
            } else if (quantity == "6") {
                defaultCollection = campaign__6;
            }
            if (!defaultCollection) return alert('Please select a quantity or talk to our support team.');
            const prepaidProduct = defaultCollection.filter(product => product.handle === handlePrepaid)[0];
            const weeklyProduct = defaultCollection.filter(product => product.handle === handleWeekly)[0];
            const priceWeekly = card.querySelector('.weekly-price');
            const pricePrepaid = card.querySelector('.prepaid-price');
            priceWeekly.innerHTML = `$${(weeklyProduct.variants[0].price / 100).toFixed(0)}`;
            pricePrepaid.innerHTML = ` <s>$${(prepaidProduct.variants[0].compare_at_price / 100).toFixed(0)}</s>  $${(prepaidProduct.variants[0].price / 100).toFixed(0)}`;
            const savings = (prepaidProduct.variants[0].compare_at_price / 100) - (prepaidProduct.variants[0].price / 100);
            card.querySelector('.savings').innerHTML = `$${savings.toFixed(0)}`;
            card.querySelector(".qty-per-week").innerHTML = quantity;
            card.querySelector(".total-qty").innerHTML = quantity * 8;
            card.dataset.weeklyProductId = weeklyProduct.id;
            card.dataset.prepaidProductId = prepaidProduct.id;
        });
    })

    buttons.forEach(button => {
        button.addEventListener('click', function (e) {
            window.pagesense = window.pagesense || [];
            window.pagesense.push(['trackEvent', 'Select One Package']);
            const card = e.target.closest('.product_card-one-month');
            modal.classList.add('is-active')
            const planType = button.dataset.openModal
            modal.dataset.stream = card.dataset.stream
            modal.dataset.quantity = card.dataset.quantity
            modal.dataset.planType = planType
            modal.dataset.productId = planType === "weekly" ? card.dataset.weeklyProductId : card.dataset.prepaidProductId
            if (modal.dataset.stream.includes("vegan")) {
                proteinStep.classList.remove('active')
                datesStep.classList.add('active')
            }
            document.body.classList.add('modal-open')
        })
    })
    proteinButtons.forEach(button => {
        button.addEventListener('click', function () {
            button.classList.toggle('selected')
            const proteinSelection = getProteinSelection()
            if (proteinSelection.selected.length === 0) {
                proteinContinueButton.disabled = true
            } else {
                proteinContinueButton.disabled = false
            }
        })
    })
    proteinContinueButton.addEventListener('click', function () {
        modalAllSteps.forEach(step => {
            step.classList.remove('active')
        })
        datesStep.classList.add('active')
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'one-month-proteins']);
    })

    datesStep.querySelectorAll('input').forEach(input => {
        input.addEventListener('change', function () {
            const dateSelection = getSelectedDate()
            if (dateSelection) {
                dateStepContinue.disabled = false
            } else {
                dateStepContinue.disabled = true
            }
        })
    })
    dateStepContinue.addEventListener('click', function () {
        // debugger;
        const planType = modal.dataset.planType
        const modalProduct = modal.dataset.productId
        const stream = modal.dataset.stream
        const selectedProduct = defaultCollection.filter(product => parseInt(product.id) == parseInt(modalProduct))[0]
        const paymentType = planType == "weekly" ? "/week)" : " for 8 weeks)"
        const productWithBreakfast = defaultCollection.filter(product => {
            if (product.handle.includes(stream) &&
                product.tags.find(tag => tag.includes(`campaign_payment_option:${planType}`)) &&
                product.tags.find(tag => tag == "campaign_bft_with_breakfast")) {
                return product
            }
        })[0]
        if (!productWithBreakfast) {
            alert("Product with breakfast not found, please contact our support team.")
            throw new Error('Product with breakfast not found')
        }
        let breakfastQuantity = 0;
        if (modal.dataset.quantity == "10") {
            breakfastQuantity = 5;
        }
        if (modal.dataset.quantity == "8") {
            breakfastQuantity = 3;
        }
        if (modal.dataset.quantity == "6") {
            breakfastQuantity = 2;
        }
        modal.dataset.breakfastProductId = productWithBreakfast.id
        modal.querySelector(".breakfast-per-week").innerHTML = `${breakfastQuantity} breakfasts per week`
        modal.querySelector(".include-breakfast .price").innerHTML = "<br>($" + (productWithBreakfast.variants[0].price - selectedProduct.variants[0].price) / 100 + paymentType

        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'one-month-date']);
        modalAllSteps.forEach(step => {
            step.classList.remove('active')
        })
        breafastStep.classList.add('active')

    })

    breafastStep.querySelector("button.continue").addEventListener('click', function () {
        modalAllSteps.forEach(step => {
            step.classList.remove('active')
        })
        const summary = modal.querySelector('.summary')
        const hasBreakfast = breafastStep.querySelector('input').checked
        const quantity = modal.dataset.quantity
        const totalQty = quantity * 8
        const planType = modal.dataset.planType
        summary.innerHTML = `
        <p class="bullet-box">✅ Fresh ready-to-eat healthy meals</p>
        <p class="bullet-box">✅ Chef Prepared Restaurant Quality Meals</p>
        <p class="bullet-box">✅ New menu every week. Never get bored!</p>
        <p class="bullet-box">✅ Delivered to your door</p>
        <p class="bullet-box">✅ ${quantity} meals per week</p>
        <p class="bullet-box">✅ Total of ${totalQty} meals </p>
        ${planType == "weekly" ? `<p class="bullet-box">✅ No commitment, skip or cancel anytime</p>` :
                `<p class="bullet-box">✅ Prepaid plan</p>`}
        ${hasBreakfast ? `<p class="bullet-box">✅ Breakfast included</p>` : ''}
        `
        confirmationStep.classList.add('active')
    })

    confirmationStep.querySelector("button.continue").addEventListener('click', async function () {
        // debugger;
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'one-month-checkout-click']);
        const dateSelection = getSelectedDate()
        const proteinSelection = getProteinSelection()
        const includeBreakfast = breafastStep.querySelector('input').checked
        //const message = breafastStep.querySelector('textarea').value
        //const recipient = breafastStep.querySelector('input').value
        const productId = includeBreakfast ? modal.dataset.breakfastProductId : modal.dataset.productId
        const product = defaultCollection.filter(product => parseInt(product.id) == parseInt(productId))[0]
        const variantId = product.variants[0].id
        const subscription_id = modal.dataset.planType == "weekly" ? product.variants[0].selling_plan_allocations[0].selling_plan_id : false
        const dateText = luxon.DateTime.fromMillis(dateSelection.timestamp).toISODate()
        const props = {
            "_Delivery-Group": dateSelection['group-number'],
            "_One-Month-Trial": "true"
        }
        const notSelectedProteins = proteinSelection.notSelected.length > 0 ? proteinSelection.notSelected : false
        if (notSelectedProteins) {
            notSelectedProteins.forEach(protein => {
                props["_restriction_" + protein] = true
            })
        }
        if (!product.handle.includes("vegan")) {
            props["_restriction_vegan"] = true
        }
        const data = {
            items: [
                {
                    'id': variantId,
                    'quantity': 1,
                    "properties": props
                }
            ],
            attributes: {
                "Checkout-Method": "delivery",
                "Delivery-Location-Id": "173071",
                "Delivery-Date": dateText.replaceAll("-", "/")
            }
        }
        if (subscription_id) {
            data.items[0].selling_plan = parseInt(subscription_id)
        }
        try {
            const response = await fetch('/cart/add.js', {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/json'
                },
                body: JSON.stringify(data),
            });
            const json = await response.json();
            window.location.href = '/checkout?locale=en-US&method=delivery';
        } catch (error) {
            alert('An error occurred, please try again or contact our support team.')
            console.error(error);
        }
    })

})
function clearAllProteinSelection() {
    const proteinButtons = document.querySelectorAll('.protein-group button')
    proteinButtons.forEach(button => {
        button.classList.remove('selected')
    })
}
function verifyMessage() {
    const modal = document.querySelector('.x-mas-modal--container')
    const breafastStep = modal.querySelector('[data-step="message"]')
    const message = breafastStep.querySelector('textarea').value
    const recipient = breafastStep.querySelector('input').value
    // verifica se tem mensagem, se tive verifica se é menor que 500 ch
    // verifica se tem nome do destinatario
    // se tiver tudo certo, habilita o botao de continuar
    if (message.length > 0) {
        if (message.length < 500) {
            if (recipient.length > 0) {
                return true
            } else {
                alert('Please, enter the recipient name.')
                return false
            }
        } else {
            alert('Your message is too long. Please, shorten it.')
            return false
        }
    }
    return true;
}

function getProteinSelection() {
    const proteinButtons = document.querySelectorAll('.protein-group button')
    let proteinSelection = { selected: [], notSelected: [] }
    proteinButtons.forEach(button => {
        if (button.classList.contains('selected')) {
            proteinSelection.selected.push(button.dataset.protein)
        } else {
            proteinSelection.notSelected.push(button.dataset.protein)
        }
    })
    return proteinSelection
}

function getSelectedDate() {
    const date = document.querySelector('.delivery-groups input:checked')
    if (date) {
        return {
            'start-date': date.dataset.startDate,
            'group-number': date.value,
            'timestamp': parseFloat(date.id),
        }
    } else {
        return false
    }
}

function populateDeliveryGroups() {
    function getNumberWithOrdinal(n) {
        var s = ['th', 'st', 'nd', 'rd'],
            v = n % 100;
        return n + (s[(v - 20) % 10] || s[v] || s[0]);
    }

    const active_groups = activeDeliveryGroups();
    let content = '';

    active_groups.forEach((group, index) => {
        const date = group.delivery; // Converting to Luxon DateTime
        const startDate = date.setLocale('en').toFormat('EEEE - LLL dd, yyyy');
        const wrap = `
        <div class="input-wrapper">
          <label for="${date.toMillis()}">
            <b><i class="fa-regular fa-calendar"></i> ${startDate}</b>
          </label>
          <input
            type="radio"
            name="starting-on"
            id="${date.toMillis()}"
            data-start-date='${startDate}' value="${group.number}"
          >
        </div>`;

        content = content + wrap;
    });

    document.querySelector('.delivery-groups').innerHTML = content;
}

function activeDeliveryGroups() {
    const system_date = luxon.DateTime.now().setZone('America/Toronto');
    const groups = [];
    const startDate = luxon.DateTime.fromISO('2025-01-19T00:00:00', { zone: 'America/Toronto' });
    const deadlineDate = luxon.DateTime.fromISO('2025-01-17T09:59:59', { zone: 'America/Toronto' });

    for (let i = 0; i < 51; i++) {
        groups.push({
            number: i + 1,
            delivery: startDate.plus({ weeks: i }),
            deadline: deadlineDate.plus({ weeks: i }),
        });
    }
    groups.forEach((group) => {
        if (group.deadline > system_date) {
            group.active = true;
        } else {
            group.active = false;
        }
    });
    const activeGroups = groups.filter((group) => group.active);
    //sort by date
    activeGroups.sort((a, b) => a.delivery - b.delivery);
    return activeGroups.slice(0, 4);
}


function checkElementVisibility() {
    const elementX = document.querySelector('.products---wrapper');
    const elementXRect = elementX.getBoundingClientRect();
    const windowHeight = window.innerHeight;

    if (elementXRect.top < windowHeight && elementXRect.bottom >= 0) {
        window.pagesense = window.pagesense || [];
        window.pagesense.push(['trackEvent', 'Choose the package section']);
        window.removeEventListener('scroll', checkElementVisibility);
    }
}

window.addEventListener('scroll', checkElementVisibility);
